import { WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE_GRID } from '../../../../webcomponents.constants';
import { AtlassianJiraConfluenceGridWebComponent } from './component/AtlassianJiraConfluenceGridWebComponent';

export { AtlassianJiraConfluenceGridWebComponent };

window.customElements.define(
  WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE_GRID,
  AtlassianJiraConfluenceGridWebComponent
);
